<template>
    <download-landing v-if="!downloadType || downloadType==0"
    :layoutType="2" :styleType="1" :contImgUrl="contImgUrl"
    :contBtnImgUrl="contBtnImgUrl_01" :contLinkPath="contLinkPath_01"
    :contBtnImgUrl_02="contBtnImgUrl_02" :contLinkPath_02="contLinkPath_02"></download-landing>
    <download-landing v-else-if="downloadType && downloadType==2" :contImgUrl="contImgUrl"
    :contBtnImgUrl="contBtnImgUrl" :contLinkPath="contLinkPath"
    :class="curClass"></download-landing>
</template>
<script>
export default {
    data(){
        return {
            downloadType: this.$route.query.downloadType ? parseInt(this.$route.query.downloadType) : 0, //下载类型: 0:客户端下载(默认), 2:客户经理端下载, 3:阿姨端
            contImgUrl: require("../../../shared/assets/images/download/download_landing_club_show_181008.png"), //内容图片
            contBtnImgUrl: require("../../../shared/assets/images/download/download_landing_club_btn.png"), //内容按钮图片
            contLinkPath: "https://itunes.apple.com/cn/app/id1405594920", //内容跳转链接
            
            contBtnImgUrl_01: require("../../../shared/assets/images/download/download_landing_club_btn_01_181008.png"), //内容按钮图片
            contBtnImgUrl_02: require("../../../shared/assets/images/download/download_landing_club_btn_02_181008.png"),
            contLinkPath_01: "https://itunes.apple.com/cn/app/id1405594920", //内容跳转链接
            contLinkPath_02: "https://tqu.oss-cn-shanghai.aliyuncs.com/app/UPlusClient.apk",
            curClass: "", //当前自定义样式
        }
    },
    mounted() {
        this.init();
    },
    watch: {
        '$route': function(to, from) {
            if (to && to.name === 'downloadLanding') {
                this.init();
            }
        }
    },
    methods:{
        init(){
            this.downloadType = this.$route.query.downloadType ? parseInt(this.$route.query.downloadType) : 0;
            switch (this.downloadType) {
                case 0:
                    this.contImgUrl = require("../../../shared/assets/images/download/download_landing_club_show_181008.png");
                    this.contBtnImgUrl = require("../../../shared/assets/images/download/download_landing_club_btn.png");
                    this.contLinkPath = "https://itunes.apple.com/cn/app/id1405594920";
                    this.curClass = "";
                    break;
                case 2:
                    this.contImgUrl = require("../../../shared/assets/images/download/download_landing_ally_show.jpg");
                    this.contBtnImgUrl = require("../../../shared/assets/images/download/download_landing_ally_btn.png");
                    this.contLinkPath = "https://tqu.oss-cn-shanghai.aliyuncs.com/app/UPlusAlly.apk";
                    this.curClass = "download-landing-ally";
                    break;
                default: break;
            }
        },
    }
}
</script>
<style>
.download-landing-ally{
    background-color: #f5f4f3 !important;
}
.download-landing-ally .cont-btn{
    padding: 0.5rem 0 0.1rem !important;
    margin: 0.5rem auto 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/ally/page/service/download-landing.vue